import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { configuration } from "../../appConfig";
import ReportImages from "./ReportImages";
import PhotoGalleryImages from "./PhotoGalleryImages";
import PhotoGalleryOtherExtraImages from "./PhotoGalleryOtherExtraImages";
import PhotoGalleryBulkImages from "./PhotoGalleryBulkImages";
import PhotoGalleryTotalCarLossImages from "./PhotoGalleryTotalCarLossImages";
import PreDamageImages from "./PreDamageImages";
import "./allImagesReport.css";
import "./allImagesReportPrintMode.css";
import ReportDamageImages from "./ReportDamageImages";
import ExtraDocumentsImage from "./ExtraDocumentsImage";
import axios from "axios";
import { error } from "jquery";
import ExtendReportImages from "./ExtendReportImages";
import DamageExtendReportImages from "./DamageExtendReportImages";
import BrowseImages from "./BrowseImages";
import ReportPaintImages from "./ReportPaintImages";
import ReportFullGeneralDamageImage from "../ReportFullGeneralDamageImage";
import ReportDamageImagesNew from "./ReportDamageImagesNew";
import ReportImagesNew from "./ReportImagesNew";

export class AllReportScanImages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "gb",
      words: {},
      extraImagesArr: [],
      documentImagesArr: [],
      browseImagesArr: [],
      otherextraImagesArr: [], // for pre-damage and damage uploaded image from photo galary
      otherDamageExtraImageArr: [], // for pre-damage and damage uploaded image from photo galary
      Extra11DocumentImageArr: [],
      bulkImagesArr: [],
      totalCarLossImagesArr: [],
      bulkImages: [],
      preDamageImagesArr: [],
      PreDamage: "",
      preDamageFilterImages: [],
      isExtraImages: "",
      jsonData: [],
      allExtraImagesArr: [
        "vehicleRegistrationDocument",
        "Mileage",
        "chassisNumber",
        "QRCodeFrontPage",
        "QRCodeOnTheBack",
        "paymentDetails",
        "frontLeft",
        "frontRight",
        "backLeft",
        "backRight",
        "Roof",
        "pre-Damage-1",
        "pre-Damage-2",
        "pre-Damage-3",
        "pre-Damage-4",
      ],
      alltotalCarLossImagesArr: [
        "RightVehicleidentificationpageWithoutcontrolshield",
        "Front",
        "Teil",
        "Trunk-extra",
        "1wheel",
        "Enginecompartment",
        "WholeDashboard",
        "Frontseat",
        "Seatrear",
        "BeltsBeltTighteners",
        "InstrumentdisplaywithKMandRunningengine",
        "ServicebookletCarkey",
        "PurchaseInvoiceReceipt",
        "Leasingcontract",
        "Investments",
        "Invoice",
        "additionalimage-1",
        "additionalimage-2",
      ],
      // allPreDamageImagesArr : [
      //     "foggy_L",
      //     "meglena_D",
      //     "headlamp_L",
      //     "headlamp_D",
      //     "ventilationGrille",
      //     "emblem",
      //     "pvcLiningUnderVS_L",
      //     "pvcLiningUnderVS_D",
      //     "frontWiperLCover",
      //     "frontWiperDCover",
      //     "windscreen",
      //     "roofRail_L",
      //     "roofRail_D",
      //     "roofAntenna",
      //     "luggageCoverSpoiler",
      //     "luggageCoverGlass",
      //     "rearWiperCover",
      //     "interiorBrakeLight_L",
      //     "interiorBrakeLight_D",
      //     "fenderTurnSignal_L",
      //     "mirrorOutside_L",
      //     "turnSignalOnExteriorMirror_L",
      //     "doorHandle_EN",
      //     "doorTrimLower_EN",
      //     "slidingWindowTrim_EN",
      //     "topDoorSash_EN",
      //     "doorUpright_SL",
      //     "doorHandle_ZL",
      //     "doorTrimBelow_ZL",
      //     "slidingWindowSlat_ZL",
      //     "topDoorSash_ZL",
      //     "doorHinge_ZL",
      //     "zlDoorStile",
      //     "tankCover",
      //     "windowTriangle_ZL",
      //     "brakeLightExternal_L",
      //     "fenderTurnSignal_D",
      //     "mirrorOutside_D",
      //     "turnSignalOnOutsideMirror_D",
      //     "doorHandle_SD",
      //     "doorTrimLower_SD",
      //     "slidingWindowTrim_SD",
      //     "doorTrimAbove_SD",
      //     "doorStile_SD",
      //     "sdDoorHandle",
      //     "sdDoorTrimBelow",
      //     "slidingWindowMoulding_ZD",
      //     "upperDoorLeaf_ZD",
      //     "zdDoorUpStand",
      //     "zdDoorStile",
      //     "windowTriangle_ZD",
      //     "LeftFrontTyreRim",
      //     "LeftFrontTyre",
      //     "LeftBackTyreRim",
      //     "LeftBackTyre",
      //     "RightFrontTyreRim",
      //     "RightFrontTyre",
      //     "RightBackTyreRim",
      //     "RightBackTyre",
      // ],
      // allPreDamageImagesArr: [
      //   "Hood", //1
      //   "LeftFrontFender", //2
      //   "RightFrontFender", //3
      //   "LeftFrontDoor", //4
      //   "RightFrontDoor", //5
      //   "LeftBackDoor", //6
      //   "RightBackDoor", //7
      //   "LeftBackFender", //8
      //   "RightBackFender", //9
      //   "Trunk", //10
      //   "TrunkCover", //11
      //   "Roof", //12
      //   "LeftRoofFrame", //13
      //   "RightRoofFrame", //14
      //   "SideFenderTurnSignalRepeaterLampL", //15
      //   "FenderTrimPlateFL", //16
      //   "DecorStickerOfRoofFrameL", //17
      //   "SideViewMirrorL", //18
      //   "SideMirrorRepeaterLampL", //19
      //   "OuterUpperDoorWindowTrim_Crom_FL", //20
      //   "UprightOuterDoorCover_PlateFL", //21
      //   "OuterLowerDoorWindowSlotSeal_Crom_FL", //22
      //   "SideWindowFL", //23
      //   "DoorHandleFL", //24
      //   "Rocker_RunningPanelFL_DecorStrip", //25
      //   "UprightOuterDoorCover_PlateFirstOneBL", //26
      //   "OuterUpperDoorWindowTrim_Crom_BL", //27
      //   "UprightOuterDoorCover_PlateSecondOneBL", //28
      //   "OuterLowerDoorWindowSlotSeal_Crom_BL", //29
      //   "SideWindowBL", //30
      //   "DoorHandleBL", //31
      //   "Rocker_RunningPanelBL_DecorStrip", //32
      //   "QuarterWindowBL", //33
      //   "QuarterWindowTrim_Crom_BL", //34
      //   "FuelTankDoor", //35
      //   "FenderTrimPlateBL", //36
      //   "TailLightOuterL", //37
      //   "RearWindshieldDecorTrimL", //38
      //   "FogLightL", //39
      //   "FogLightR", //40
      //   "HeadlightL", //41
      //   "HeadlightR", //42
      //   "RadiatorGrille", //43
      //   "HoodEmblem", //44
      //   "CoverForPlenumChamberL", //45
      //   "CoverForPlenumChamberR", //46
      //   "WindshieldWiperL_ArmCap", //47
      //   "WindshieldWiperR_ArmCap", //48
      //   "Windshield", //49
      //   "WindshieldDecorTrimR", //50
      //   "WindshieldDecorTrimL", //51
      //   "RoofDripMoldingL", //52
      //   "RoofDripMoldingR", //53
      //   "SunRoof", //54
      //   "RoofRailL", //55
      //   "RoofRailR", //56
      //   "FenderBR", //57
      //   "RoofFrameR", //58
      //   "HighMountStopLight", //59
      //   "RearWindshield", //60
      //   "WiperForRearWindshield_ArmCap", //61
      //   "TrunkEmblem", //62
      //   "Emblem", //63
      //   "TailLightInnerL", //64
      //   "TailLightInnerR", //65
      //   "SideFenderTurnSignalRepeaterLampR", //66
      //   "FenderTrimPlateFR", //67
      //   "DecorStickerOfRoofFrameR", //68
      //   "SideViewMirrorR", //69
      //   "SideMirrorRepeaterLampR", //70
      //   "OuterUpperDoorWindowTrim_Crom_FR", //71
      //   "UprightOuterDoorCover_PlateFR", //72
      //   "OuterLowerDoorWindowSlotSeal_Crom_FR", //73
      //   "SideWindowBR", //74
      //   "DoorHandleFR", //75
      //   "Rocker_RunningPanelFR_DecorStrip", //76
      //   "UprightOuterDoorCover_PlateFirstOneBR", //77
      //   "OuterUpperDoorWindowTrim_Crom_BR", //78
      //   "UprightOuterDoorCover_PlateSecondOneBR", //79
      //   "OuterLowerDoorWindowSlotSeal_Crom_BR", //80
      //   "SideWindowBR", //81
      //   "DoorHandleBR", //82
      //   "Rocker_RunningPanelBR_DecorStrip", //83
      //   "QuarterWindowBR", //84
      //   "QuarterWindowTrim_Crom_BR", //85
      //   "FenderTrimPlateBR", //86
      //   "TailLightOuterR", //87
      //   "RearWindshieldDecorTrimR", //88
      //   "FrontBumper", //89
      //   "LeftFrontTyre", //90
      //   "LeftBackTyre", //91
      //   "RightFrontTyre", //92
      //   "RightBackTyre", //93
      // ],
      allPreDamageImagesArr: [
        "svg_Hood", //1
        "svg_LeftFrontFender", //2
        "svg_RightFrontFender", //3
        "svg_LeftFrontDoor", //4
        "svg_RightFrontDoor", //5
        "svg_LeftBackDoor", //6
        "svg_RightBackDoor", //7
        "svg_LeftBackFender", //8
        "svg_RightBackFender", //9
        "svg_Trunk", //10
        "svg_TrunkCover", //11
        "svg_Roof", //12
        "svg_LeftRoofFrame", //13
        "svg_RightRoofFrame", //14
        "svg_SideFenderTurnSignalRepeaterLampL", //15
        "svg_FenderTrimPlateFL", //16
        "svg_DecorStickerOfRoofFrameL", //17
        "svg_SideViewMirrorL", //18
        "svg_SideMirrorRepeaterLampL", //19
        "svg_OuterUpperDoorWindowTrim_Crom_FL", //20
        "svg_UprightOuterDoorCover_PlateFL", //21
        "svg_OuterLowerDoorWindowSlotSeal_Crom_FL", //22
        "svg_SideWindowFL", //23
        "svg_DoorHandleFL", //24
        "svg_Rocker_RunningPanelFL_DecorStrip", //25
        "svg_UprightOuterDoorCover_PlateFirstOneBL", //26
        "svg_OuterUpperDoorWindowTrim_Crom_BL", //27
        "svg_UprightOuterDoorCover_PlateSecondOneBL", //28
        "svg_OuterLowerDoorWindowSlotSeal_Crom_BL", //29
        "svg_SideWindowBL", //30
        "svg_DoorHandleBL", //31
        "svg_Rocker_RunningPanelBL_DecorStrip", //32
        "svg_QuarterWindowBL", //33
        "svg_QuarterWindowTrim_Crom_BL", //34
        "svg_FuelTankDoor", //35
        "svg_FenderTrimPlateBL", //36
        "svg_TailLightOuterL", //37
        "svg_RearWindshieldDecorTrimL", //38
        "svg_FogLightL", //39
        "svg_FogLightR", //40
        "svg_HeadlightL", //41
        "svg_HeadlightR", //42
        "svg_RadiatorGrille", //43
        "svg_HoodEmblem", //44
        "svg_CoverForPlenumChamberL", //45
        "svg_CoverForPlenumChamberR", //46
        "svg_WindshieldWiperL_ArmCap", //47
        "svg_WindshieldWiperR_ArmCap", //48
        "svg_Windshield", //49
        "svg_WindshieldDecorTrimL", //50
        "svg_WindshieldDecorTrimR", //51
        "svg_RoofDripMoldingL", //52
        "svg_RoofDripMoldingR", //53
        "svg_SunRoof", //54
        "svg_RoofRailL", //55
        "svg_RoofRailR", //56
        "svg_Antenna", //57
        "svg_TrunckCover_Spoiler", //58
        "svg_HighMountStopLight", //59
        "svg_RearWindshield", //60
        "svg_WiperForRearWindshield_ArmCap", //61
        "svg_TrunkEmblem", //62
        "svg_Emblem", //63
        "svg_TailLightInnerL", //64
        "svg_TailLightInnerR", //65
        "svg_SideFenderTurnSignalRepeaterLampR", //66
        "svg_FenderTrimPlateFR", //67
        "svg_DecorStickerOfRoofFrameR", //68
        "svg_SideViewMirrorR", //69
        "svg_SideMirrorRepeaterLampR", //70
        "svg_OuterUpperDoorWindowTrim_Crom_FR", //71
        "svg_UprightOuterDoorCover_PlateFR", //72
        "svg_OuterLowerDoorWindowSlotSeal_Crom_FR", //73
        "svg_SideWindowFR", //74
        "svg_DoorHandleFR", //75
        "svg_Rocker_RunningPanelFR_DecorStrip", //76
        "svg_UprightOuterDoorCover_PlateFirstOneBR", //77
        "svg_OuterUpperDoorWindowTrim_Crom_BR", //78
        "svg_UprightOuterDoorCover_PlateSecondOneBR", //79
        "svg_OuterLowerDoorWindowSlotSeal_Crom_BR", //80
        "svg_SideWindowBR", //81
        "svg_DoorHandleBR", //82
        "svg_Rocker_RunningPanelBR_DecorStrip", //83
        "svg_QuarterWindowBR", //84
        "svg_QuarterWindowTrim_Crom_BR", //85
        "svg_FenderTrimPlateBR", //86
        "svg_TailLightOuterR", //87
        "svg_RearWindshieldDecorTrimR", //88
        "svg_FrontBumper", //89
        "svg_LeftFrontTyre", //90
        "svg_LeftBackTyre", //91
        "svg_RightFrontTyre", //92
        "svg_RightBackTyre", //93
        "svg_BackBumper", //94
      ],
      allExtraDocumentImageArr: [
        "NC-NoteOfFinding",
        "CI-IdentityCard",
        "RegistrationCertificate",
        "RepairEstimate",
        "ServiceContract",
        "LeasingAuthorization",
        "CompanyAuthorization",
        "CascoPolicy",
        "DamageDeclaration",
        "DrivingLicense",
        "OtherDocuments",
      ],
      showReportDamageImages: 0,
      showExtraDocumentImage: 0,
      extendedImageViewlabel: 0,
      isDentShowingReport: 0,
      defaultReportImages: 0,
      paintImageArray: [],
      isPaintImage: "",
    };
  }
  componentDidMount() {
    this.getLang();
    this.getAllExtraImages();
    this.getData();
    this.getFallBackDetails();
    this.getScanImages();
  }

  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  getData = () => {
    Axios.get(
      `${configuration.getData}?vin=${localStorage.getItem(
        "selectedFile"
      )}&partnerId=${localStorage.getItem("partnerId")}`
    )
      .then((r) => {
        if (r.data) {
          this.setState({
            PreDamage: r.data.PreDamage,
            jsonData: r.data.Dents,
          });
        }
      })
      .catch((error) => alert("An error occured please try again"));
  };
  getFallBackDetails = () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    axios
      .get(url)
      .then((res) => {
        if (res && res.data) {
          this.setState({
            showReportDamageImages: res.data.is_damage_image,
            showExtraDocumentImage: res.data.is_document_show,
            extendedImageViewlabel: res.data.extended_view,
            isDentShowingReport: res.data.dent_showing,
            defaultReportImages: res.data.is_default_damage_image,
          });
        }
      })
      .catch((err) => {
        //  throw error(err)
      });
  };

  getAllExtraImages = () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedVIN = localStorage.getItem("selectedFile");
    const url = `${configuration.getExtraImages}?partnerId=${partnerId}&vin=${selectedVIN}&partName=yes`;
    Axios.get(url)
      .then((res) => {
        this.props.setImageLoading(false);

        if ((res && res.data.extraImages) || res.data.extraNewImages) {
          let otherextraImages = [];
          const filterArray = res.data.extraNewImages.filter((item) => {
            return item.part.includes("pre-damage-");
          });
          const reverseFilteredArray = [...filterArray].reverse();

          let mergedArr = [...res.data.extraImages, ...reverseFilteredArray];
          for (let i = 0; i < mergedArr.length; i += 6) {
            otherextraImages = [
              ...otherextraImages,
              [
                [mergedArr[i], mergedArr[i + 1]],
                [mergedArr[i + 2], mergedArr[i + 3]],
                [mergedArr[i + 4], mergedArr[i + 5]],
              ],
            ];
          }

          this.setState({ otherextraImagesArr: otherextraImages });
        }
        if (res.data.extraNewImages) {
          let documentExtraImg = [];
          const filterArray = res.data.extraNewImages.filter((item) => {
            return item.part.includes("document");
          });

          const uniqueDocArr = filterArray.filter((value, index, self) => {
            return self.findIndex((v) => v.part === value.part) === index;
          });

          const sortedDocArr = uniqueDocArr.sort((a, b) => {
            const numA = parseInt(a.part.split("-")[1], 10);
            const numB = parseInt(b.part.split("-")[1], 10);
            return numA - numB;
          });

          for (let i = 0; i < sortedDocArr.length; i += 6) {
            documentExtraImg = [
              ...documentExtraImg,
              [
                [sortedDocArr[i], sortedDocArr[i + 1]],
                [sortedDocArr[i + 2], sortedDocArr[i + 3]],
                [sortedDocArr[i + 4], sortedDocArr[i + 5]],
              ],
            ];
          }

          this.setState({ documentImagesArr: documentExtraImg });
          ////
          let browseExtraImg = [];
          const browseFilterArr = res.data.extraNewImages.filter((item) => {
            return item.part.includes("browse");
          });

          const uniqueBrowseArr = browseFilterArr.filter(
            (value, index, self) => {
              return self.findIndex((v) => v.part === value.part) === index;
            }
          );

          const sortedBrowseArr = uniqueBrowseArr.sort((a, b) => {
            const numA = parseInt(a.part.split("-")[1], 10);
            const numB = parseInt(b.part.split("-")[1], 10);
            return numA - numB;
          });

          for (let i = 0; i < sortedBrowseArr.length; i += 6) {
            browseExtraImg = [
              ...browseExtraImg,
              [
                [sortedBrowseArr[i], sortedBrowseArr[i + 1]],
                [sortedBrowseArr[i + 2], sortedBrowseArr[i + 3]],
                [sortedBrowseArr[i + 4], sortedBrowseArr[i + 5]],
              ],
            ];
          }

          this.setState({ browseImagesArr: browseExtraImg });

          let Extra11DocumentImage = [];
          const documentImagePartsSet = new Set(
            this.state.allExtraDocumentImageArr
          );

          const documentImageOrderMap = new Map();
          Array.from(documentImagePartsSet).forEach((part, index) => {
            documentImageOrderMap.set(part, index);
          });

          const filterExtraDocArray = res.data.extraNewImages.filter((item) =>
            documentImagePartsSet.has(item.part)
          );

          filterExtraDocArray.sort((a, b) => {
            const orderA = documentImageOrderMap.get(a.part);
            const orderB = documentImageOrderMap.get(b.part);
            return orderA - orderB;
          });

          for (let i = 0; i < filterExtraDocArray.length; i += 6) {
            Extra11DocumentImage = [
              ...Extra11DocumentImage,
              [
                [filterExtraDocArray[i], filterExtraDocArray[i + 1]],
                [filterExtraDocArray[i + 2], filterExtraDocArray[i + 3]],
                [filterExtraDocArray[i + 4], filterExtraDocArray[i + 5]],
              ],
            ];
          }

          this.setState({ Extra11DocumentImageArr: Extra11DocumentImage });
        }

        // if(res.data && res.data.extraImages){
        //     let otherextraImages = [];
        //     for (let i = 0; i < res.data.extraImages.length; i += 6) {
        //       otherextraImages = [
        //         ...otherextraImages,
        //         [
        //           [res.data.extraImages[i], res.data.extraImages[i + 1]],
        //           [res.data.extraImages[i + 2], res.data.extraImages[i + 3]],
        //           [res.data.extraImages[i + 4], res.data.extraImages[i + 5]],
        //         ],
        //       ];
        //     }
        //     this.setState({otherextraImagesArr: otherextraImages});
        // }
        if (res.data && res.data.bulkImages) {
          const sortedArray = [...res.data.bulkImages].sort(
            (a, b) => a.order - b.order
          );
          this.setState({
            bulkImages: sortedArray,
          });
          let otherextrabulkImages = [];
          for (let i = 0; i < this.state.bulkImages.length; i += 6) {
            otherextrabulkImages = [
              ...otherextrabulkImages,
              [
                [this.state.bulkImages[i], this.state.bulkImages[i + 1]],
                [this.state.bulkImages[i + 2], this.state.bulkImages[i + 3]],
                [this.state.bulkImages[i + 4], this.state.bulkImages[i + 5]],
              ],
            ];
          }
          this.setState({ bulkImagesArr: otherextrabulkImages });
        }
        if (res.data.extraNewImages && res.data.extraNewImages.length) {
          // res.data.extraNewImages.sort((a, b) => {
          //   return partPosition[a.part] - partPosition[b.part];
          // });

          let extraNewImages = [];
          const sortedImages =
            res.data.extraNewImages &&
            res.data.extraNewImages.length > 0 &&
            res.data.extraNewImages.slice().sort((a, b) => {
              const orderA = this.state.allPreDamageImagesArr.findIndex(
                (item) => item === a.part
              );
              const orderB = this.state.allPreDamageImagesArr.findIndex(
                (item) => item === b.part
              );
              return orderA - orderB;
            });

          const documentImagePartsSet = new Set(
            this.state.allExtraDocumentImageArr
          );

          const filterArray = sortedImages.filter((item) => {
            return (
              !item.part.includes("pre-damage-") &&
              !item.part.includes("document") &&
              !item.part.includes("browse") &&
              !documentImagePartsSet.has(item.part)
            );
          });

          for (let i = 0; i < filterArray.length; i += 6) {
            extraNewImages = [
              ...extraNewImages,
              [
                [filterArray[i], filterArray[i + 1]],
                [filterArray[i + 2], filterArray[i + 3]],
                [filterArray[i + 4], filterArray[i + 5]],
              ],
            ];
          }

          this.setState({ preDamageImagesArr: extraNewImages });
        }
        if (res && res.data) {
          this.setState({ tempExtraImagesArr: res.data }, () =>
            this.getImageOrder()
          );
        }
      })
      .catch((err) => {
        this.props.setImageLoading(false);
      });
  };

  getImageOrder = () => {
    const { tempExtraImagesArr, allExtraImagesArr, alltotalCarLossImagesArr } =
      this.state;
    let finalExtraImagesArr = [];
    let finalTempExtraImg = allExtraImagesArr.filter(
      (obj) => !Array.isArray(tempExtraImagesArr[obj])
    );
    const filterArray = finalTempExtraImg.filter(
      (name) => !name.includes("pre-Damage")
    );
    this.setState({ isExtraImages: filterArray.length > 0 ? true : false });
    for (let i = 0; i < filterArray.length; i += 6) {
      finalExtraImagesArr = [
        ...finalExtraImagesArr,
        [
          [filterArray[i], filterArray[i + 1]],
          [filterArray[i + 2], filterArray[i + 3]],
          [filterArray[i + 4], filterArray[i + 5]],
        ],
      ];
    }
    this.setState({
      extraImagesArr: finalExtraImagesArr,
    });

    let finalTotalCarLossImages = [];
    let finalTempTotalCarLossImages = alltotalCarLossImagesArr.filter(
      (obj) => !Array.isArray(tempExtraImagesArr[obj])
    );
    for (let i = 0; i < finalTempTotalCarLossImages.length; i += 6) {
      finalTotalCarLossImages = [
        ...finalTotalCarLossImages,
        [
          [finalTempTotalCarLossImages[i], finalTempTotalCarLossImages[i + 1]],
          [
            finalTempTotalCarLossImages[i + 2],
            finalTempTotalCarLossImages[i + 3],
          ],
          [
            finalTempTotalCarLossImages[i + 4],
            finalTempTotalCarLossImages[i + 5],
          ],
        ],
      ];
    }
    this.setState({
      totalCarLossImagesArr: finalTotalCarLossImages,
    });
  };
  getScanImages = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({
      damageImageLoader: true,
    });

    try {
      const response = await Axios.get(configuration.getScanImages, {
        params: {
          partnerId: partnerId,
          vin: selectedFile,
        },
      });

      if (response && response.data) {
        const { data } = response;
        if (data.paint && data.paint.length > 0) {
          let groupedImages = [];
          let imageArray = data.paint;
          for (let i = 0; i < imageArray.length; i += 6) {
            groupedImages.push([
              [imageArray[i] || null, imageArray[i + 1] || null],
              [imageArray[i + 2] || null, imageArray[i + 3] || null],
              [imageArray[i + 4] || null, imageArray[i + 5] || null],
            ]);
          }

          this.setState({ paintImageArray: groupedImages, isPaintImage: true });
        } else {
          this.setState({ paintImageArray: [], isPaintImage: false });
        }
      }
    } catch (error) {
      console.error("Error fetching scan images:", error);
      this.setState({
        damageImageLoader: false,
        paintImageArray: [],
        isPaintImage: false,
      });
    }
  };
  render() {
    const {
      lang,
      words,
      extraImagesArr,
      otherDamageExtraImageArr,
      otherextraImagesArr,
      bulkImagesArr,
      totalCarLossImagesArr,
      tempExtraImagesArr,
      preDamageImagesArr,
      PreDamage,
      allPreDamageImagesArr,
      isExtraImages,
      documentImagesArr,
      showReportDamageImages,
      Extra11DocumentImageArr,
      showExtraDocumentImage,
      jsonData,
      extendedImageViewlabel,
      isDentShowingReport,
      defaultReportImages,
      browseImagesArr,
    } = this.state;
    return (
      <>
        {this.props.imageLoading === false && (
          <>
            {showReportDamageImages == 1 &&
              this.props.toggleReportDamageImage == true ? (
              <>
                {extendedImageViewlabel == 0 ? (
                  <>
                    {
                      configuration.imagePath == "https://backend.drivenscan.live" ?
                        (
                          <ReportDamageImagesNew
                            lang={lang}
                            words={words}
                            jsonData={jsonData}
                            isDentShowingReport={isDentShowingReport}
                          />
                        ) : (
                          <ReportDamageImages
                            lang={lang}
                            words={words}
                            jsonData={jsonData}
                            isDentShowingReport={isDentShowingReport}
                          />
                        )
                    }
                  </>

                ) : (
                  <DamageExtendReportImages
                    lang={lang}
                    words={words}
                    jsonData={jsonData}
                    isDentShowingReport={isDentShowingReport}
                  />
                )}
                {configuration.imagePath ==
                  "https://backend.drivenscan.live" && (
                    <ReportPaintImages
                      paintImageArray={this.state.paintImageArray}
                      lang={lang}
                      words={words}
                      isPaintImage={this.state.isPaintImage}
                    />
                  )}
              </>
            ) : extendedImageViewlabel == 0 ? (
              <>
                {
                  configuration.imagePath == "https://backend.drivenscan.live" ?
                    (
                      <ReportImagesNew
                        lang={lang}
                        words={words}
                        jsonData={jsonData}
                        isDentShowingReport={isDentShowingReport}
                      />
                    ) : (
                      <ReportImages
                        lang={lang}
                        words={words}
                        jsonData={jsonData}
                        isDentShowingReport={isDentShowingReport}
                      />
                    )
                }
              </>
            ) : (
              <ExtendReportImages
                lang={lang}
                words={words}
                jsonData={jsonData}
                isDentShowingReport={isDentShowingReport}
              />
            )}

            <ExtraDocumentsImage
              documentImagesArr={documentImagesArr}
              lang={lang}
              words={words}
              isExtraImages={isExtraImages}
              extra11Image={false}
            />
            <BrowseImages
              browseImagesArr={browseImagesArr}
              lang={lang}
              words={words}
              isExtraImages={isExtraImages}
            />
            {showExtraDocumentImage == 1 && (
              <ExtraDocumentsImage
                documentImagesArr={Extra11DocumentImageArr}
                lang={lang}
                words={words}
                isExtraImages={isExtraImages}
                extra11Image={true}
              />
            )}

            <PhotoGalleryImages
              extraImagesArr={extraImagesArr}
              tempExtraImagesArr={tempExtraImagesArr}
              lang={lang}
              words={words}
              isExtraImages={isExtraImages}
            />

            <PhotoGalleryOtherExtraImages
              otherextraImagesArr={otherextraImagesArr}
              otherDamageExtraImageArr={otherDamageExtraImageArr}
              lang={lang}
              words={words}
            />

            <PhotoGalleryBulkImages
              bulkImagesArr={bulkImagesArr}
              lang={lang}
              words={words}
            />

            <PhotoGalleryTotalCarLossImages
              totalCarLossImagesArr={totalCarLossImagesArr}
              tempExtraImagesArr={tempExtraImagesArr}
              lang={lang}
              words={words}
            />

            <PreDamageImages
              preDamageImagesArr={preDamageImagesArr}
              allPreDamageImagesArr={allPreDamageImagesArr}
              PreDamage={PreDamage}
              lang={lang}
              words={words}
            />
            {
              configuration.imagePath == "https://backend.drivenscan.live" &&
              <ReportPaintImages
                paintImageArray={this.state.paintImageArray}
                lang={lang}
                words={words}
                isPaintImage={this.state.isPaintImage}
              />
            }
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (props, state) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage,
  };
};
export default connect(mapStateToProps)(AllReportScanImages);
